import * as React from "react";
import { translateSubElementString } from "../../../../../../../../utils";
import { Flex, Text } from "@chakra-ui/react";
import { NumberField } from "../../../../../../../../components/NumberField";
import CategoryPreviewWrapper from "../CategoryPreviewWrapper";
import { CapitalGoods } from "./components";

function CapitalGoodsPreview({ currentElement, reportId }) {
  return (
    <CategoryPreviewWrapper>
      <Flex marginBlockEnd={4}>
        <Text size="sm" fontWeight="bold">
          {translateSubElementString(
            "reportsPage.scopeThree.inputs.mainTotalEmissions"
          )}
        </Text>
        <NumberField value={currentElement?.totalCo2Emissions ?? ""} marginStart="2" />
      </Flex>
      <CapitalGoods data={currentElement} reportId={reportId} />
    </CategoryPreviewWrapper>
  );
}

export default CapitalGoodsPreview;
